import React from 'react';
import { Box, Skeleton } from '@ublend-npm/aulaui-core';
import Divider from '@mui/material/Divider';

export const OutlookAllEmailsRowSkeleton = ({
  compact = false,
}: {
  compact?: boolean;
}) => {
  return (
    <Box
      display="flex"
      gap={1.5}
      alignItems="flex-start"
      width="100%"
      py={compact ? 1 : 1.25}
      px={{ xs: 1, sm: 2 }}
      sx={{ boxSizing: 'border-box' }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={{ xs: 0.5, sm: 0.75 }}
        flexShrink={0}
        pt={0.25}
      >
        <Skeleton
          kind="circular"
          width={compact ? 32 : 38}
          height={compact ? 32 : 38}
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        minWidth={0}
        flex={1}
        gap={0.75}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Skeleton kind="text" width="40%" height={16} />
          <Skeleton kind="text" width="15%" height={14} />
        </Box>
        <Skeleton kind="text" width="75%" height={16} />
        <Skeleton kind="text" width="90%" height={14} />
      </Box>
    </Box>
  );
};

export const OutlookAllEmailsSkeleton = ({ count = 6 }: { count?: number }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      minHeight={0}
      width="100%"
    >
      {Array.from({ length: count }).map((_, i) => (
        <React.Fragment key={i}>
          <OutlookAllEmailsRowSkeleton />
          <Divider sx={{ width: '100%', mx: 0, my: 0 }} />
        </React.Fragment>
      ))}
    </Box>
  );
};

export default OutlookAllEmailsSkeleton;
